import { DefaultPrimaryButton, DefaultSecondaryButton, Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { KioskNavigationFooter } from '../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import KioskRadioButton from '../../components/kiosk-radio-button/kiosk-radio-button.component';
import { useMoveSelectSpot } from './move-select-spot.controller';

const ID = 'move-select-spot';

const MoveSelectSpot = () => {
    const viewProps = useMoveSelectSpot();

    return (
        <div
            id={ID}
            className='bg-background-default flex size-full flex-col overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={viewProps.handleBack}
            />

            <div className='flex flex-1 flex-col gap-4 overflow-y-auto p-6'>
                {viewProps.isLoading && (
                    <div className='flex flex-1 items-center justify-center'>
                        <Spinner />
                    </div>
                )}
                {!viewProps.isLoading && viewProps.error && <div className='text-status-danger'>{viewProps.error}</div>}
                {!viewProps.isLoading && !viewProps.error && (
                    <>
                        <p className='text-foreground-default text-lg font-semibold'>
                            <FormattedMessage
                                id='kiosk.manage-spot.move-transaction.select-spot.title'
                                defaultMessage='Select destination distriSPOT'
                                description='Title on the manage-spot move transaction distriSPOT selection screen'
                            />
                        </p>
                        <div className='flex w-full flex-col gap-3'>
                            {viewProps.spots.map((spot) => (
                                <KioskRadioButton
                                    key={spot.id}
                                    id={`${ID}-${spot.id}`}
                                    text={spot.name}
                                    selected={viewProps.selectedSpotId === spot.id}
                                    onClick={() => viewProps.setSelectedSpotId(spot.id)}
                                />
                            ))}
                            {viewProps.spots.length === 0 && (
                                <span className='text-brand-muted'>
                                    <FormattedMessage
                                        id='kiosk.manage-spot.move-transaction.select-spot.empty'
                                        defaultMessage='No distriSPOTs available'
                                        description='Empty state when the logged-in user has no readable distriSPOTs for move transaction'
                                    />
                                </span>
                            )}
                        </div>
                    </>
                )}
            </div>

            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={viewProps.handleBack}
                    />
                }
                rightButton={
                    <DefaultPrimaryButton
                        text={CommonMessage.BUTTONS.CONTINUE}
                        onClick={viewProps.handleContinue}
                        disabled={!viewProps.canContinue}
                    />
                }
            />
        </div>
    );
};

export default MoveSelectSpot;
